import React from 'react';
import { CustomCarousel } from '../CustomCarousel';

export const CardCarouselBlock = ({ cards, articleTitleColor }) => {
    const titleStyle = articleTitleColor ? { color: articleTitleColor } : undefined;
    return (
        <CustomCarousel>
            {cards.map((card, index) => (
                <a
                    className="cardcarouselblock__article"
                    key={index}
                    href={card.Url}
                >
                    {(() => {
                        const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'];
                        const TitleTag = allowedTags.includes(card.TitleTag) ? card.TitleTag : 'h3';
                        return <TitleTag style={titleStyle}>{card.Title}</TitleTag>;
                    })()}
                    <div
                        className="cardcarouselblock__editor-content"
                        dangerouslySetInnerHTML={{
                            __html: card.Description,
                        }}
                    ></div>
                    {card.ReadMoreText && (
                        <div className="cardcarouselblock__link">
                            <p>{card.ReadMoreText}</p>
                            <i className="cardcarouselblock__icon"></i>
                        </div>
                    )}
                </a>
            ))}
        </CustomCarousel>
    );
};
